<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/LZzuHs/tc-custom/9781429925754.jpg?1737196285949" alt="This image is the cover for the book Death of an Angel, St. Martin's True Crime Classics"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Death of an Angel, St. Martin's True Crime Classics
      </h1>
      <p class="bookDescription body article font2">
        <b>From a <i>New York Times</i>–bestselling author, the true crime story of a Rhode Island family murdered by a Sunday school teacher.</b><br/><br/>When prosperous lawyer Ernest Brendel mysteriously disappeared, along with his wife Alice, and their eight-year-old daughter Emily, friends in the close-knit Rhode Island neighborhood worried that family had been kidnapped. It would be agonizing months in a massive FBI search before they would know the heartbreaking truth.<br/><br/>The shaken community began to lose hope that the family would ever be found alive. Their worst fears were confirmed when heavy rains from a tropical storm uncovered Alice and Ernest Brendel’s badly decomposed bodies—shot with a giant crossbow, strangled, and buried in the quiet woods of the town. Lying under her mother’s corpse was little Emily’s lifeless body, now a silent witness to her killer’s shocking identity.<br/><br/>Like a hand pointing from the grave, the evidence led authorities to one of Ernest Brendel’s closest and most trusted friends. What Ernest couldn’t have known was that Christopher Hightower—a Sunday school teacher and respected member of the community—was a psychotic liar obsessed with greed, jealousy, and murderous revenge.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Donald Davis
      </h2>
      
      <p class="authorDescription body article"><P><B>Donald A. Davis</B> is co-author of <I>New York Times</I> bestseller <I>Shooter: The Autobiography of the Top-Ranked Marine Sniper</I> and author of <I>Lightning Strike: The Secret Mission to Kill Admiral Yamamoto and Avenge Pearl Harbor</I>. He lives outside Boulder, Colorado.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?34525ffc